import fetch from './fetch'

class RulesApi {
	public getRuleList(form: any) {
		return fetch({
			url: 'injury/wholeprocess/config/list',
			method: 'post',
			data: form,
		})
	}

	public toggleStatus(form: any) {
		return fetch({
			url: 'injury/wholeprocess/config/enable',
			method: 'get',
			params: form,
		})
	}

	public removeRule(ruleId: string) {
		return fetch({
			url: 'injury/wholeprocess/config/delete',
			method: 'get',
			params: {
				ruleId,
			},
		})
	}

	public saveRule(form: any) {
		return fetch({
			url: 'injury/wholeprocess/config/save',
			method: 'POST',
			data: form,
		})
	}

	public getRuleDetail(ruleId: string) {
		return fetch({
			url: 'injury/wholeprocess/config/detail',
			method: 'GET',
			params: {
				ruleId,
			},
		})
	}

	public manualPreview(fileId: string) {
		return fetch({
			url: 'injury/manual/pdfPreview',
			method: 'POST',
			data: {
				fileId,
			},
		})
	}
}

export default new RulesApi()
